<app-navbar *ngIf="!(location == '/error')"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/error')"></app-footer>
